if (typeof Promise.withResolvers === 'undefined') {
	Promise.withResolvers = function () {
		var resolve, reject;
		var promise = new Promise(function (res, rej) {
			resolve = res;
			reject = rej;
		});
		return { promise: promise, resolve: resolve, reject: reject };
	};
}

if (typeof Promise.try === 'undefined') {
	Promise.try = function (fn) {
		return new Promise(function (resolve) {
			resolve(fn());
		});
	};
}